import { useEffect } from 'react';

/**
 * Attaches pointer tracking to all elements matching a CSS selector.
 * Sets --pointer-x and --pointer-y CSS variables for glow/highlight effects.
 */
export function usePointerTracking(selector) {
  useEffect(() => {
    const cards = document.querySelectorAll(selector);

    const updatePosition = (card, event) => {
      const rect = card.getBoundingClientRect();
      const x = (event.clientX - (rect.left + rect.width / 2)) / (rect.width / 2);
      const y = (event.clientY - (rect.top + rect.height / 2)) / (rect.height / 2);
      card.style.setProperty('--pointer-x', Math.max(-1, Math.min(1, x)));
      card.style.setProperty('--pointer-y', Math.max(-1, Math.min(1, y)));
    };

    const handlers = Array.from(cards).map((card) => {
      const onEnter = (e) => updatePosition(card, e);
      const onMove = (e) => updatePosition(card, e);
      const onLeave = () => {
        card.style.setProperty('--pointer-x', '-10');
        card.style.setProperty('--pointer-y', '-10');
      };
      card.addEventListener('pointerenter', onEnter);
      card.addEventListener('pointermove', onMove);
      card.addEventListener('pointerleave', onLeave);
      return { card, onEnter, onMove, onLeave };
    });

    return () => {
      handlers.forEach(({ card, onEnter, onMove, onLeave }) => {
        card.removeEventListener('pointerenter', onEnter);
        card.removeEventListener('pointermove', onMove);
        card.removeEventListener('pointerleave', onLeave);
      });
    };
  }, [selector]);
}
